var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          staticClass: "button",
          class: [
            "button_type-" + _vm.type,
            "button_theme-" + _vm.theme,
            { "button_is-active": _vm.button_is_active },
          ],
          style: {
            width: _vm.width,
            margin: _vm.margin,
            padding: _vm.padding,
            fontSize: _vm.font_size,
          },
          attrs: { type: _vm.is_submit ? "submit" : "button" },
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.$slots.default
        ? _c("div", { staticClass: "button__content" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm.type === "custom-toggle"
        ? _c(
            "div",
            { staticClass: "button__custom-toggle" },
            [_vm._t("custom_toggle")],
            2
          )
        : _vm._e(),
      _vm.type === "custom-toggle"
        ? _c(
            "div",
            {
              staticClass: "button__custom-toggle button__custom-toggle_active",
            },
            [_vm._t("custom_toggle_active")],
            2
          )
        : _vm._e(),
      _vm.type === "custom-background"
        ? _c("div", {
            staticClass: "button__custom-background",
            style: {
              backgroundImage: "url(" + _vm.custom_background[0] + ")",
            },
          })
        : _vm._e(),
      _vm.type === "custom-background"
        ? _c("div", {
            staticClass:
              "button__custom-background button__custom-background_is-active",
            style: {
              backgroundImage: "url(" + _vm.custom_background[1] + ")",
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }